/**
 * Product card image carousel
 * Enables swiping through all product images directly on a product card.
 * Works for every card variant, in any section, on all devices.
 * Handles cards that are inserted dynamically (filters, recently viewed,
 * infinite scroll, quick view, etc.) via a MutationObserver.
 */
(function () {
  'use strict';

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.carouselInit) return;

    var track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-carousel-slide]');
    if (slides.length <= 1) return;

    carousel.dataset.carouselInit = '1';

    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');

    function currentIndex() {
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(index) {
      var count = slides.length;
      // Infinite loop: wrap around at both ends.
      if (index < 0) {
        index = count - 1;
      } else if (index >= count) {
        index = 0;
      }
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex() - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex() + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(parseInt(dot.getAttribute('data-carousel-dot'), 10) || 0);
      });
    });

    if (dots.length) {
      var syncTimer;
      // Redesign 2026: show at most MAX_DOTS dots; the window slides with the current image
      // (Instagram style) and the end dots shrink when more images sit beyond them.
      var MAX_DOTS = 3;   // user 2026-10-02: three dots (was 4)
      var syncDots = function () {
        var idx = currentIndex(), n = dots.length;
        var start = n <= MAX_DOTS ? 0 : Math.min(Math.max(idx - 1, 0), n - MAX_DOTS);
        dots.forEach(function (dot, i) {
          var inWin = i >= start && i < start + MAX_DOTS;
          dot.classList.toggle('active', i === idx);
          dot.classList.toggle('kj-dot-hide', !inWin);
          dot.classList.toggle('kj-dot-sm', inWin && i !== idx && ((i === start && start > 0) || (i === start + MAX_DOTS - 1 && start + MAX_DOTS < n)));
        });
      };
      syncDots();
      track.addEventListener('scroll', function () {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(syncDots, 50);
      }, { passive: true });
    }

    // Distinguish a swipe/drag from a tap so dragging doesn't follow the slide link.
    var startX = 0;
    var dragged = false;
    track.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      dragged = false;
    });
    track.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - startX) > 8) dragged = true;
    });
    slides.forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        if (dragged) e.preventDefault();
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-card-carousel]').forEach(initCarousel);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    initAll(document);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-card-carousel]')) {
            initCarousel(node);
          }
          if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
